import Pad from './Pad'
import type { PadState } from './padState'

type Props = {
  pads: PadState[]
  playingIndex: number | null
  onFile: (index: number, file: File) => void
  onPlayToggle: (index: number) => void
  onClear: (index: number) => void
}

export default function PadGrid({ pads, playingIndex, onFile, onPlayToggle, onClear }: Props) {
  return (
    <div className="pad-grid" role="list">
      {pads.map((state, i) => (
        <Pad
          key={i}
          index={i}
          state={state}
          isPlaying={playingIndex === i}
          onFile={onFile}
          onClick={onPlayToggle}
          onClear={onClear}
        />
      ))}
    </div>
  )
}
